<template>
    <rkm-form ref="RkmForm">
        <rkm-row>
            <rkm-col>
                <rkm-form-input-autocomplete
                    :repository="repositories.parametrizacao.servicoEnfermagem"
                    :requestQueryStringParams="{
                        paciente_id: data.form.paciente.id,
                        search_by_apelido: additionals.searchByApelido,
                    }"
                    :searchFields="fields"
                    :text-field="p => `${this.formatProcedimento(p.codigo)} - ${p.nome}`"
                    :validations="validations.procedimento"
                    label="Procedimento"
                    v-model="model.procedimento"
                />
            </rkm-col>
        </rkm-row>
        <rkm-row>
            <rkm-col>
                <rkm-form-input
                    :validations="validations.observacoes"
                    label="Observações"
                    v-model="model.observacoes"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
//Enums
import statusExame from '@/enums/pronto-atendimento/statusExame'

// Mixins.
import { formats, repository } from '@/mixins'

export default {
    computed: {
        fields() {
            return [{ key: 'nome', searchable: true }, { key: 'codigo', searchable: true }]
        },
        validations() {
            return {
                procedimento: { required: true },
                observacoes: { max: 100 },
            }
        },
    },
    created() {
        this.repositories = {
            parametrizacao: this.getConectaSusRepository('prontoAtendimento.parametrizacao')
        }
    },
    data: () => ({
        additionals: {
            searchByApelido: false,
        },
        enums: { statusExame },
    }),
    methods: {
        handleDestroy(item) {
            const destroy = () => new Promise(resolve => {
                resolve(this.model.servicosEnfermagem.splice(this.model.servicosEnfermagem.findIndex(servicoenfermagem => servicoenfermagem.id === item.id), 1))
            })

            this.showDeleteConfirmation('Tem certeza que deseja excluir?', destroy)
        },
        save() {
            this.$refs.RkmForm.validate().then(response => {

                if (response === true) {

                    const duplicado = this.data.model.servicosEnfermagem
                        .find(item => {

                            if (!Number.isInteger(item.id)) {

                                return item.procedimento.id === this.model.procedimento.id
                            }

                            return false
                        })

                    if (duplicado) {
                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: `Este serviço de enfermagem já foi cadastrado.`
                        })
                    } else {
                        if (this.model.id) {
                            const index = this.data.model.servicosEnfermagem.findIndex(item => item.id === this.model.id)
                            Object.assign(this.data.model.servicosEnfermagem[index], this.model)
                        } else {
                            this.data.model.servicosEnfermagem.push({
                                id: this.uniqueId('pronto-atendimento-atendimento-medico-servicoenfermagem'),
                                status: {
                                    id: this.enums.statusExame.SOLICITADO,
                                    nome: 'SOLICITADO'
                                },
                                lotacao: {
                                    ocupacao: {
                                        codigo: this.data.form.lotacao.ocupacao.codigo,
                                    },
                                    profissional: {
                                        nome: this.data.form.lotacao.profissional.nome,
                                    },
                                },
                                procedimento: this.model.procedimento,
                                observacoes: this.model.observacoes,
                            })
                        }

                        this.$emit('saved', this.model)
                    }
                }
            })
        },
    },
    mixins: [formats, repository],
    props: {
        data: { type: Object, required: true },
        model: { type: Object, required: true },
    },
}
</script>